"use client";
import { motion } from "motion/react";
import Image from "next/image";

interface Ideal {
  Title: string;
  Description: string;
  Images: string;
}

interface IdealSectionProps {
  ideals: Ideal[];
}

export default function IdealSection({ ideals }: IdealSectionProps) {
  if (!ideals || ideals.length === 0) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
      {ideals.map((item, index) => (
        <motion.div
          key={index}
          className="group"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.15 }}
          viewport={{ once: true }}
        >
          <div className="relative aspect-square rounded-3xl overflow-hidden mb-8 shadow-2xl">
            <Image
              src={item?.Images}
              alt={item?.Title}
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              className="object-cover group-hover:scale-110 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8">
              {/* <div className="inline-block p-4 bg-white/10 backdrop-blur-sm rounded-full mb-4">
                          <item.icon className="h-8 w-8 text-white" />
                        </div> */}
              <h3 className="text-white text-2xl mb-2">{item?.Title}</h3>
              <p
                className="text-white/90 text-sm leading-relaxed"
                dangerouslySetInnerHTML={{
                  __html: item?.Description,
                }}
              />
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
